import Utils from '../../modules/utils'

const getQuickbooksAccountNames = (callbackFunc) => {
  const url = 'sales_history_accounts'
  Utils.get(url, callbackFunc)
}

export {getQuickbooksAccountNames}
